const features = [
  {
    icon: 'ri-drop-line',
    title: 'Ultra Kaliteli UV Baskı',
    desc: 'Endüstriyel UV baskı makinelerimizle solmayan, canlı renkler ve keskin detaylar elde ediyoruz. Güneş ışığına ve hava koşullarına dayanıklı.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Kolay Değişebilen Panel Sistemi',
    desc: 'Lightbox sistemlerimiz, görsel değişimini kolaylaştıracak şekilde tasarlanmıştır. Kampanya dönemlerinde hızlı güncelleme imkânı.',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: 'Her Bütçeye Uygun Çözüm',
    desc: 'Küçük işletmelerden büyük zincir markalara kadar her bütçeye uygun lightbox çözümleri sunuyoruz. Toplu siparişlerde özel fiyatlar.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Özel Proje Seçeneği',
    desc: 'Standart ürünlerimizin yanı sıra tamamen özel ölçü, şekil ve tasarımda lightbox üretimi yapıyoruz. Hayalinizdeki projeyi gerçeğe dönüştürüyoruz.',
  },
  {
    icon: 'ri-time-line',
    title: 'Uzun Ömürlü Malzeme',
    desc: 'Alüminyum profil kasa, yüksek kaliteli LED modüller ve UV dayanımlı baskı malzemeleri ile üretilen lightboxlarımız 10+ yıl sorunsuz kullanım sunar.',
  },
  {
    icon: 'ri-sun-line',
    title: 'Homojen LED Aydınlatma',
    desc: 'Özel difüzör panel ve LED dizilim teknolojimizle tüm yüzeyde eşit, titreşimsiz ve gölgesiz aydınlatma sağlıyoruz.',
  },
];

export default function WhyUs() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image with badge */}
          <div className="relative">
            <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-4">
              <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
              Neden Biz?
            </div>
            <h2 className="text-4xl font-black text-gray-900 leading-tight mb-6">
              Neden Bizi <br />
              <span className="text-red-600">Tercih Etmelisiniz?</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Her işletmenin ihtiyacı farklıdır. Biz de her müşterimize özel çözümler sunarak, 
              markanızın en iyi şekilde temsil edilmesini sağlıyoruz. 
              Lightbox dünyasında 15 yılı aşkın deneyimimizle yanınızdayız.
            </p>

            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="/images/whyus/whyus-section.webp"
                alt="Lightbox Üretim Tesisi"
                className="w-full h-48 md:h-64 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-4">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-red-600 rounded-lg">
                    <i className="ri-award-line text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">ISO 9001 Sertifikalı</div>
                    <div className="text-gray-500 text-xs">Kalite Yönetim Sistemi</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Features grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((f) => (
              <div
                key={f.title}
                className="bg-white rounded-2xl p-6 group hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-xl mb-4 group-hover:bg-red-600 transition-colors duration-300">
                  <i className={`${f.icon} text-red-600 text-xl group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <h3 className="font-bold text-gray-900 text-base mb-2">{f.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
